import React from 'react';

export const PrivilegesContext = React.createContext(new Set());
